import {Injectable} from '@angular/core';
import {LocalStorageService} from '../local-storage.service';
import {ObjektModels} from '../models/objekt-models';
import {Md5} from 'ts-md5';

@Injectable({
  providedIn: 'root'
})
export class SwissInternService {

  private storageSwissIntern: string = 'SwissInternDB';

  constructor(private localStorageService: LocalStorageService,) {
  }


  async SaveRapportPositions(objectID: string, positionen: ObjektModels.ObjektRapportPosition[]) {
    await this.localStorageService.add(objectID, positionen, this.storageSwissIntern);
  }

  getPositionsFromIndexedDB(objectID: string): Promise<ObjektModels.ObjektRapportPosition[]> {
    return new Promise((resolve) => {
      this.localStorageService.get(objectID, this.storageSwissIntern).then((value) => {
        if (value === false) {
          resolve([]);
        } else {
          resolve(<ObjektModels.ObjektRapportPosition[]> (value));
        }
      });
    });
  }

  getEncryptedValue(value: string): string {
    if (value) {
      return Md5.hashStr(value);
    } else {
      return '';
    }
  }
}
